import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import { createIssue } from '../../store/actions/restaurantActions'
import { Redirect, NavLink } from 'react-router-dom'
import Review from './reviews'

class Contact2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
    	message: ''
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value
    });  
  }

  messageConfirmInterruptor =(e)=>{
  	e.preventDefault();
  	if(this.state.message!==""){
  		document.getElementById("messageConfirm"+this.props.auth.uid).style.display = "block";
  	}

  }

  handleMessageConfirm = (e)=>{
  	e.preventDefault();
  	this.props.createIssue(this.state.message);
    document.getElementById("messageConfirm"+this.props.auth.uid).style.display = "none";
    this.setState({redirect:true});

  }

   handleEditorChange = (content, editor) => {
     this.setState({
      message:content
     })
   }

   handleInit = (e, editor) => {
    var resizeWidth=document.getElementById('container').offsetWidth - 10;
    editor.dom.setStyle(editor.container, 'width', resizeWidth + 'px');
   }


  render(){
  	const {auth, user, issues} = this.props
  	if (!auth.uid) return <Redirect to='/signin' />
  	if (this.state.redirect) return <Redirect to='/'/>

  	return(
  		
  		<div className='container'>
  		{ auth && user && issues 
        && (issues.filter(issue=>issue.userId === auth.uid).length < 1 || user.firstName !== "Guest") &&

  		<div className='outerReviewContainer'> 
  		<div className='reviewContainer3' id="starContainer">
        	<div style={{"width":"100%", "display":"flex", "justifyContent":"space-around", "textAlign":"center"}}>
  		  	<h5  id="container">Please provide a brief description of your issue.</h5>
  		  </div>
      </div>
      <div className='reviewContainer3'>  
        
  			<div className="input-field2" id="editorParent">
            <Editor
             apiKey = "j1avn6800qx0kl1a8g28hwd9j85dwvja7qg8r7o62tl4vxaf"
             id = 'tinyMce'
             initialValue=""
             onInit={this.handleInit}
             init={{
               height: 300,
               // width: 500,
               menubar: false,
               plugins: [
                  'autoresize',
                 'advlist autolink lists link image charmap print preview anchor',
                 'searchreplace visualblocks code fullscreen',
                 'insertdatetime media table paste code help wordcount'
               ],
               toolbar:
                 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help'
             }}
             onEditorChange={this.handleEditorChange}
            />
          <div style={{"display": "flex", "justifyContent": "center", "paddingTop":"5px"}}>  
            <button className="btn pink lighten-1" onClick={this.messageConfirmInterruptor}>Submit</button>
          </div>
          <div style={{"display": "flex", "justifyContent": "center", "paddingTop":"5px"}}>  
          <div id={"messageConfirm"+auth.uid} style={{"display":"none"}}>
          	<button className="btn pink lighten-1" onClick={this.handleMessageConfirm}>Confirm</button>  
        	</div>
        	</div>
        </div>
  
        </div>
        </div>
      }
      {
        auth && user && issues 
        && issues.filter(issue=>issue.userId === auth.uid).length > 0 
        && user.firstName === "Guest" &&
        <div style={{textAlign:"center"}}>
        <br/><br/><br/>
        <h3>You may not add issues at this time.</h3>
        <p> Guests are limited to one pending issue.</p>
        <p> Please wait until your current pending issues are resolved. </p>
        <p> You can delete pending issues on your user page. </p>
        <NavLink to='/about/points' >About the point system</NavLink>
        </div>

      }
  		</div>

  	)
  }

}

const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    issues: state.firestore.ordered.issues,
    points: state.firestore.data.points,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createIssue: (message) => dispatch(createIssue(message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact2)